import React from "react";
import "./Loader.scss";

const Loader: React.FC<any> = () => {
  return <div className="loader"></div>;
};

export default Loader;
